/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoryList_lists$ref = any;
export type DeleteCategoryInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type deleteCategoryMutationVariables = {|
  input: DeleteCategoryInput
|};
export type deleteCategoryMutationResponse = {|
  +deleteCategory: ?{|
    +destroyedCategoryId: string,
    +lists: {|
      +$fragmentRefs: CategoryList_lists$ref
    |},
  |}
|};
export type deleteCategoryMutation = {|
  variables: deleteCategoryMutationVariables,
  response: deleteCategoryMutationResponse,
|};
*/


/*
mutation deleteCategoryMutation(
  $input: DeleteCategoryInput!
) {
  deleteCategory(input: $input) {
    destroyedCategoryId
    lists {
      ...CategoryList_lists
      id
    }
  }
}

fragment CategoryCell_category on Category {
  id
  name
}

fragment CategoryCell_lists on Lists {
  id
}

fragment CategoryList_lists on Lists {
  ...CategoryCell_lists
  categories(first: 1000) {
    edges {
      node {
        id
        ...CategoryCell_category
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCategoryInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destroyedCategoryId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCategoryPayload",
        "kind": "LinkedField",
        "name": "deleteCategory",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CategoryList_lists"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCategoryPayload",
        "kind": "LinkedField",
        "name": "deleteCategory",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "CategoryConnection",
                "kind": "LinkedField",
                "name": "categories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Category",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "categories(first:1000)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CategoryList_categories",
                "kind": "LinkedHandle",
                "name": "categories"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation deleteCategoryMutation(\n  $input: DeleteCategoryInput!\n) {\n  deleteCategory(input: $input) {\n    destroyedCategoryId\n    lists {\n      ...CategoryList_lists\n      id\n    }\n  }\n}\n\nfragment CategoryCell_category on Category {\n  id\n  name\n}\n\nfragment CategoryCell_lists on Lists {\n  id\n}\n\nfragment CategoryList_lists on Lists {\n  ...CategoryCell_lists\n  categories(first: 1000) {\n    edges {\n      node {\n        id\n        ...CategoryCell_category\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '96c247a3134f4ca2b3173c5fe5e0ab69';

module.exports = node;
